import { Status } from "../../models/Status";

export const RESET_PASSWORD_STATUS = "RESET_PASSWORD_STATUS";
export const RESET_PASSWORD_USERNAME = " RESET_PASSWORD_USERNAME";

export type IState = {
  status: Status;
  username: string;
};
